import { useEffect } from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useBlockUserMutation } from "../../../../../redux/apiSlice";

export const BlockUserModal = ({ showBlockUserModal, onHide, details }) => {
    const [
        blockUser, // This is the mutation trigger
        {
            isLoading: isChanging,
            isSuccess: changedSuccessfully,
        }, // This is the destructured mutation result
    ] = useBlockUserMutation();

    /* Close Modal on Successful Action */
    useEffect(() => {
        if (changedSuccessfully) {
            cogoToast.success("Block User Action Created successfully");
            onHide();
        }
    }, [changedSuccessfully, onHide]);

    /* Submit handler */
    const onSubmit = (values) => {
        blockUser({
            userId: details?.userId,
            username: details?.username,
            status: "DISABLED",
            reason: values?.reason?.trim(),
            meta: { status: details?.status || "DISABLED" },
        });
    };

    return (
        <Modal
            show={showBlockUserModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isChanging ? "static" : true}
            keyboard={!isChanging}
        >
            <Formik
                initialValues={{ status: "DISABLED", reason: "" }}
                validationSchema={Yup.object({
                    reason: Yup.string().trim().required("Disable reason is required"),
                })}
                onSubmit={onSubmit}
            >
                {({ values, handleChange, handleBlur, errors, touched }) => (
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {`Block ${details?.username}?`}
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Are you sure you want to block this user?</p>
                        <FormLayout.Group>
                            <FormLayout.Label>Disable Reason*</FormLayout.Label>
                            <FormLayout.Control
                                as="textarea"
                                rows={4}
                                name="reason"
                                value={values?.reason}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter the reason for disabling this user"
                                isInvalid={Boolean(touched?.reason && errors?.reason)}
                            />
                            {touched?.reason && errors?.reason ? (
                                <div className="text-danger mt-2">{errors.reason}</div>
                            ) : null}
                        </FormLayout.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            disabled={isChanging}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isChanging}
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Confirm
                        </button>
                    </Modal.Footer>
                </Form>
                )}
            </Formik>
        </Modal>
    );
};
